import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers';
import useSnackbar from '@core/hooks/useSnackbar';
import useFilters from '../../hooks/useFilters';

dayjs.extend(utc);
dayjs.extend(timezone);
const today = dayjs().endOf('day');
const yesterday = dayjs().subtract(1, 'day').endOf('day');

const Filters = () => {
  const [filters, setFilter] = useFilters();
  const showSnackbar = useSnackbar();

  const handleStartDate = (date: dayjs.Dayjs | null) => {
    if (date?.isBefore(dayjs(filters.end))) {
      setFilter('start', date?.startOf('day').format('YYYY-MM-DDTHH:mm:ss') || '');
      return;
    }

    showSnackbar({
      type: 'error',
      title: 'Error',
      message: 'La fecha inicial es mayor que la fecha final',
    });
  };

  const handleEndDate = (date: dayjs.Dayjs | null) => {
    if (!date?.isBefore(dayjs(filters.start))) {
      setFilter('end', date?.endOf('day').format('YYYY-MM-DDTHH:mm:ss') || '');
      return;
    }

    showSnackbar({
      type: 'error',
      title: 'Error',
      message: 'La fecha final es menor que la fecha inicial',
    });
  };

  return (
    <Box display="flex" alignItems="flex-end" gap="10px" flexDirection="row" marginLeft="auto">
      <DatePicker
        maxDate={dayjs(filters.end) || yesterday}
        value={dayjs(filters.start)}
        onChange={(date) => handleStartDate(date)}
      />
      <DatePicker
        minDate={filters.start ? dayjs(filters.start) : undefined}
        maxDate={today}
        disabled={!filters.start}
        value={dayjs(filters.end)}
        onChange={(date) => handleEndDate(date)}
      />
    </Box>
  );
};

export default Filters;
